/*
  © 2025 KondaSoft
  https://www.kondasoft.com
*/

class InstagramGallery extends HTMLElement {
  constructor() {
    super();
    
    this.handleAutoplay();
  }

  handleAutoplay() {
    const autoplay = this.getAttribute('data-autoplay') === 'true';
    if (!autoplay) return;

    let intervalId;
    const autoplayTime = Number(this.getAttribute('data-autoplay-time') || 3000);

    const startAutoplay = () => {
      intervalId = setInterval(() => {
        const items = this.querySelectorAll('.instagram-gallery-item');
        const itemWidth = items[0]?.offsetWidth || 0;
        const maxScrollLeft = this.scrollWidth - this.clientWidth;

        if (this.scrollLeft + itemWidth > maxScrollLeft) {
          this.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          this.scrollBy({ left: itemWidth, behavior: 'smooth' });
        }
      }, autoplayTime);
    };

    const stopAutoplay = () => {
      clearInterval(intervalId);
    };

    this.addEventListener('mouseenter', stopAutoplay);
    this.addEventListener('mouseleave', startAutoplay);

    startAutoplay();
  }
}
customElements.define('instagram-gallery', InstagramGallery);